import { service } from '@/utils/net'

// 奖池
export async function getRewardsPool(): Promise<
  Response<WeekStar.RewardsPool>
> {
  return service({
    method: 'GET',
    url: '/doniaLiveH5doings/week/star/activity/getRewardsPool'
  }).then((res) => res?.data)
}

// 获取奖励配置
export async function getReWardsList(): Promise<
  Response<WeekStar.RewardItem[]>
> {
  return service({
    method: 'GET',
    url: '/doniaLiveH5doings/week/star/activity/getRewards'
  }).then((res) => res?.data)
}

// 榜单
export async function getRank(rankType?: 0 | 1): Promise<Response<WeekStar.RankItem[]>> {
  return service({
    method: 'GET',
    params: {
      rankType
    },
    url: '/doniaLiveH5doings/week/star/activity/getRank'
  }).then((res) => res?.data)
}
